import * as yup from 'yup';
import { minZeroMsg, requiredMsg, typeMsg } from '../../utils/validationMessages';
import { transactionDateSchema } from '../../../../../../Finance2/Forms/transactionFieldSchemas';
import { integerField, pricePerShareField } from '../../../../../../../schemas/common-schema-defs';

export function tokenBuyFields() {
  return {
    fundId: yup.number().nullable().required(requiredMsg('Fund')),
    transactionDate: transactionDateSchema(),
    pricePerShare: pricePerShareField()
      .required()
      .min(0, minZeroMsg('Price Per Token'))
      .nullable()
      .typeError(typeMsg('Price Per Token', 'number')),
    noOfShares: integerField()
      .typeError(typeMsg('Number of Tokens', 'number'))
      .required()
      .min(0, minZeroMsg('Number of Tokens')),
  };
}

export function tokenBuyFormSchema() {
  return yup.object().shape(tokenBuyFields());
}

export function tokenBuyGridSchema() {
  return yup.object().shape(tokenBuyFields());
}
